import { useState as d, useEffect as m, createElement as p } from "react";
function w(k, f = 0) {
  let e = null, i = 0;
  return {
    call: (s) => {
      if (!e) throw new Error("No <Root> found!");
      const t = String(i++);
      let n;
      const a = new Promise((o) => {
        n = o;
      }), l = (o) => {
        if (n(o), !e) return;
        const u = e;
        f > 0 && u(
          (c) => c.map((r) => r.key !== t ? r : { ...r, ended: !0 })
        ), globalThis.setTimeout(
          () => u((c) => c.filter((r) => r.key !== t)),
          f
        );
      };
      return e((o) => [...o, { key: t, props: s, end: l, ended: !1 }]), a;
    },
    Root: (s) => {
      const [t, n] = d([]);
      return m(() => {
        if (e) throw new Error("Multiple instances of <Root> found!");
        return e = n, () => {
          e = null, i = 0;
        };
      }, []), t.map(({ props: a, ...l }) => /* @__PURE__ */ p(
        k,
        {
          ...a,
          key: l.key,
          call: { ...l, root: s }
        }
      ));
    }
  };
}
export {
  w as createCallable
};
